import React from "react"
import PropTypes from "prop-types"

import {
  CTA,
  ImageCTA,
  LogosStrip,
  TextBlock,
  ActionBar,
  Image,
  Map,
} from "./slices"

const SlicesRenderer = ({ slices }) => {
  if (!slices || slices.length === 0) return null
  return slices.map((slice, i) => {
    switch (slice.slice_type) {
      case "cta":
        return <CTA key={i} slice={slice} />
      case "image_cta":
        return <ImageCTA key={i} slice={slice} />
      case "logos_strip":
        return <LogosStrip key={i} slice={slice} />
      case "text_block":
        return <TextBlock key={i} slice={slice} />
      case "action_bar":
        return <ActionBar key={i} slice={slice} />
      case "video":
        return <LogosStrip key={i} slice={slice} />
      case "image":
        return <Image key={i} slice={slice} />
      case "map":
        return <Map key={i} slice={slice} />

      default:
        return null
    }
  })
}

SlicesRenderer.propTypes = {
  slices: PropTypes.array.isRequired,
}

export default SlicesRenderer
